export default "__VITE_ASSET__DPj16SvA__"